module.exports = {
      id: "icon-home-plus-usage",
      viewBox: "0 0 27.193 24.672",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#icon-home-plus",
      toString: function () {
        return this.url;
      }
    }